<div>
    <div class="pt-8 px-4">
        <p class="text-lg font-semibold text-black text-center pb-4">
            {{"PARKIFLY.CONFIRM_MODAL.LEAVE_PAGE" | transloco}}
        </p>
        <p class="text-sm text-[#6C757D] text-center font-normal">
            {{"PARKIFLY.CONFIRM_MODAL.WHEN_LEAVING_PAGE_1" | transloco}} <br>
            {{"PARKIFLY.CONFIRM_MODAL.WHEN_LEAVING_PAGE_2" | transloco}}
        </p>
        <p class="text-sm text-[#6C757D] text-center font-normal py-4">
            {{"PARKIFLY.CONFIRM_MODAL.WANT_TO_LEAVE" | transloco}}
        </p>
    </div>
    <div class="gap-4 flex flex-col mt-[10px] bg-black/5 py-4 px-8 sm:flex-row-reverse">
        <button class="py-3 px-8 rounded-lg font-medium text-sm leading-6 bg-[#DC0032] text-white"
            [mat-dialog-close]="true">
            {{"PARKIFLY.CONFIRM_MODAL.YES_LEAVE" | transloco}}
        </button>
        <button
            class="bg-white py-3 px-8 rounded-lg font-medium text-sm leading-6 text-[#1B3777] border border-[#1B3777]"
            mat-dialog-close>
            {{"PARKIFLY.CONFIRM_MODAL.NO_STAY" | transloco}}
        </button>
    </div>
</div>